import React, { useState, useCallback } from 'react';
import GroupSearchParams from './GroupSearchParams';
import GroupItem from '../../../Domain/UserGroup/GroupItem';
import GroupService from '../../../Services/UserGroup/GroupService';
import TabOfDataTable from '../../../Elements/DataTable/TabOfDataTable';
import ShownPanelsEnum from '../../../Enums/ShownPanelsEnum';
import FigmaButtonRow from '../../../Elements/FigmaButtonRow';
import IconPositionEnum from '../../../Enums/IconPositionEnum';
import ButtonColorsEnum from '../../../Enums/ButtonColorsEnum';
import ButtonTypeEnum from '../../../Enums/ButtonTypeEnum';
import GeneralEditWizzardBase from '../../../Elements/GeneralEditWizzard/GeneralEditWizzardBaseFigma';
import CrudTypesEnum from '../../../Enums/CrudTypesEnum';
import EditGroupWindowDescription from './EditGroupWindowDescription';

const GroupAdmin = () => {
  const [searchItem, setSearchItem] = useState(new GroupSearchParams());
  const [selectedItem, setSelectedItem] = useState(null);
  const [shownPanel, setShownPanel] = useState(ShownPanelsEnum.None);

  const clickOnEdit = useCallback((selectedId, selectedItem) => {
    setSelectedItem({ ...selectedItem });
    setShownPanel(ShownPanelsEnum.EditItem);
  }, []);

  GroupItem.editFunction = clickOnEdit;

  const refresh = useCallback(
    (refreshFlag) => {
      if (refreshFlag) {
        setShownPanel(ShownPanelsEnum.None);
        setSearchItem({ ...searchItem });
      } else {
        setShownPanel(ShownPanelsEnum.None);
      }
    },
    [searchItem]
  );

  const startSearch = useCallback((newSearchItem) => {
    setSearchItem({ ...newSearchItem });
  }, []);

  const renderOnePanel = (panelId, content) => (shownPanel === panelId ? content : null);

  const renderPanels = () => {
    const createGroupItem = new GroupItem();
    createGroupItem.IsActive = true;

    return (
      <div>
        {renderOnePanel(
          ShownPanelsEnum.AddNewItem,
          <GeneralEditWizzardBase
            crudType={CrudTypesEnum.Create}
            editedItem={createGroupItem}
            clickOnCancel={() => refresh(false)}
            clickOnSave={() => refresh(true)}
            windowDescription={EditGroupWindowDescription}
            errorCode={'GA59'}
          />
        )}
        {renderOnePanel(
          ShownPanelsEnum.EditItem,
          <GeneralEditWizzardBase
            crudType={CrudTypesEnum.Update}
            editedItem={selectedItem}
            clickOnCancel={() => refresh(false)}
            clickOnSave={() => refresh(true)}
            windowDescription={EditGroupWindowDescription}
            errorCode={'GA70'}
          />
        )}
      </div>
    );
  };

  const renderButtonsAndPanels = () => (
    <>
      <FigmaButtonRow
        buttons={[
          {
            type: ButtonTypeEnum.NormalNormal,
            color: ButtonColorsEnum.Primary,
            iconPosition: IconPositionEnum.Right,
            onClick: () => setShownPanel(ShownPanelsEnum.AddNewItem),
            label: 'Create Group',
            tooltip: 'Create Group',
            roleKey: 'group_create',
            iconName: 'fa-solid fa-plus-circle',
          },
        ]}
      />
      {renderPanels()}
    </>
  );

  return (
    <div className='contentwrapper'>
      {renderButtonsAndPanels()}
      <TabOfDataTable
        clickOnStartSearch={startSearch}
        searchParamsType={GroupSearchParams}
        searchItem={searchItem}
        showSearchStrip={true}
        serviceFunction={GroupService.GetAllItemsBySearching}
        convertDBItemsFunction={GroupService.ConvertDBItems}
        shownPanel={shownPanel}
        type={GroupItem}
        popupEnabled={true}
        singleSearchLine={true}
        singleSearchLinePlaceholder='Search by ID, name or description'
        errorCode='GA112'
      />
    </div>
  );
};

export default GroupAdmin;
